import { actionsRequest, handleRequestError } from '@/api/utils'
import { Action, ACTION_TYPE } from '@/types/action'
import { ERROR_CODE } from '@/types/error'

export const getCurrentUserConsultation = async <T extends Action<ACTION_TYPE.GET_CURRENT_USER_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.GET_CURRENT_USER_CONSULTATION
    })

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.GET_CURRENT_USER_CONSULTATION, payload)
    throw err
  }
}

export const createConsultation = async <T extends Action<ACTION_TYPE.CREATE_CONSULTATION>>(payload: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.CREATE_CONSULTATION
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.CREATE_CONSULTATION, payload)
    throw err
  }
}

export const uploadAttachment = async <T extends Action<ACTION_TYPE.UPLOAD_ATTACHMENT>>(payload: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.UPLOAD_ATTACHMENT
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.UPLOAD_ATTACHMENT, payload)
    throw err
  }
}

export const cancelConsultation = async <T extends Action<ACTION_TYPE.CANCEL_CONSULTATION>>(payload: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.CANCEL_CONSULTATION
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.CANCEL_CONSULTATION, payload)
    throw err
  }
}

export const createFollowUpConsultation = async <T extends Action<ACTION_TYPE.CREATE_FOLLOW_UP_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.CREATE_FOLLOW_UP_CONSULTATION
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.CREATE_FOLLOW_UP_CONSULTATION, payload)
    throw err
  }
}

export const rateConsultation = async <T extends Action<ACTION_TYPE.RATE_CONSULTATION>>(payload: T['payload']): Promise<T['response']> => {
  try {
    const body = await actionsRequest<T>({
      payload,
      type: ACTION_TYPE.RATE_CONSULTATION
    })

    if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

    return body.data
  } catch (err) {
    handleRequestError(err, ACTION_TYPE.RATE_CONSULTATION, payload)
    throw err
  }
}
